export const Wrapper = ({
  children,
  extraClasses,
}: {
  children: string | JSX.Element | JSX.Element[]
  extraClasses?: string
}) => (
  <div
    className={`${
      extraClasses ? extraClasses : ''
    } w-full max-w-[1900px] m-auto px-3 md:px-8`}
  >
    {children}
  </div>
)

export const WrapperSmall = ({
  children,
}: {
  children: string | JSX.Element | JSX.Element[]
}) => <div className="w-full max-w-[580px] m-auto px-8">{children}</div>
